import { provideConfig } from '@spartacus/core'
import { NgModule } from '@angular/core'
import { FsComponentConverter } from 'fs-spartacus-common'
import { PLAIN_TEASER_SPLIT_CONVERTER_TOKEN, PlainTeaserSplitConverter } from './plain-teaser-split.component.converter'

@NgModule({
  providers: [
    provideConfig({
      featureModules: {
        plainTeaserSplitFeature: {
          module: () => import('./plain-teaser-split.module').then((m) => m.PlainTeaserSplitModule),
          cmsComponents: ['plain_teaser_split'],
        },
      }
    }),
    {
      provide: PLAIN_TEASER_SPLIT_CONVERTER_TOKEN,
      useExisting: PlainTeaserSplitConverter,
      multi: true
    },
    {
      provide: FsComponentConverter,
      useValue: {
        plain_teaser_split: PLAIN_TEASER_SPLIT_CONVERTER_TOKEN
      },
      multi: true
    }
  ]
})
export class PlainTeaserSplitFeatureModule {}
